export default __webpack_public_path__ + "static/media/delete.7b0647ab.svg";